export interface Theme {
    id: number,
    name: string,
    slug: string,
};

export interface Embed {
	title: string,
	body: string,
}

export interface Media {
	id: number,
	name: string,
	alternativeText: string,
	url: string
}

export type Evenement = "Pasdevenement" | "Scoop" | "Urgent" | "Infoatlantico";

export interface RevisionInterface {
	date: number,
	author: any
	content: any,
}


export interface ReadInternInterface {
	atlantico_lights: number[],
	decryptages: number[],
	dossiers: number[],
	pepites: number[],
	podcasts: number[],
	rdvs: number[],
	videos: number[]
}

export default interface Article {
	type: string,
	data: {
		id: number,
		title: string,
        slug: string,
        theme: Theme,
		image: {
			url: string,
		}[],
		publish: boolean,
		publish_date: string
	}
}

export enum Share {
	Share,
	ShareNow,
	NoShare
};

export enum Notif {
	Notif,
	NotifNow,
	NoNotif
};